module.exports = __webpack_public_path__ + "static/cumbia.b24b7fd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apps/rcr/cumbia.png
// module id = 759
// module chunks = 168707334958949